import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import {JourneyContext} from "../context/journeyContext"
import { Swiper, SwiperSlide } from "swiper/react"
import { getAge,getValueFromJourney } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import Parser from 'html-react-parser';
import { fetchAllJourneyData } from "../../services/apiservice"
SwiperCore.use([Navigation])



const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "CPChooseYourPlan",
  "CPOptionInBuilt",
  'CPSpouseOptionBuilt'
]

const tabFormControlKey = ["CPChooseYourPlan"]
const carouselFormControlKey = ["CPCustomizePlanQuestionOne", "iSelect360CPCustomizePlanQuestionOne"]

const breakpoints = length => ({
  // when window width is <= 1023px
  1023: {
    slidesPerView: length,
    allowSlideNext: false,
    allowSlidePrev: false,
  },
  // when window width is <= 767px
  767: {
    slidesPerView: 1,
    allowSlideNext: true,
    allowSlidePrev: true,
  },
})

export default function ComponentTextSimpleRadioGroup(props) {
  const [activeTab, setActiveTab] = useState(props.data.radioComponent[0].name)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  let arr = {}

  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.formControlKey]) {
      props.data.radioComponent.map(element => {
        if (element.checked) {
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
            }
          })
        }
      })
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
        }
      })
    }
    if (props.pageId === "PagePension4lifeFillProposalForm" && props.sectionId === "SectionPension4lifeAppointeeCommunicationDetails" && props.data.formControlKey
    === "AppointeeSameAsPrimary"){
      let payload = {
        journeyId: journeyState.journeyId,
      }
      if (sectionState.sectionData.AppointeeSameAsPrimary  === undefined || sectionState.sectionData.AppointeeSameAsPrimary  === ""){
        setTimeout(() => {
          fetchAllJourneyData(payload).then(data => {
            let city = ''
            let pincode = ''
            let state = ''
            let address1 = ''
            let areaTalukaTehsil = ''
            let country = ''
            const nominees = data.nominees;
            if (nominees){
              const firstMinorNominee = nominees.find(nominee => {
                if (getAge(nominee.dob) < 18){
                  return true;
                }else{
                  return false;
                }
              })
              pincode = firstMinorNominee.communicationDetails.pinCode
              city = firstMinorNominee.communicationDetails.cityMap
              state = firstMinorNominee.communicationDetails.state
              address1 = firstMinorNominee.communicationDetails.address1
              areaTalukaTehsil = firstMinorNominee.communicationDetails.areaTalukaTehsil
              country  = firstMinorNominee.communicationDetails.country 
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["apponiteePincode"]: pincode,
                  ["appointeeState"] : state,
                  ["apponiteeCity"] : city,
                  ["addressAppointeeGuardian"] : address1,
                  ["areaTalukaTehsilApponitee"] : areaTalukaTehsil,
                  ["apponiteeCountry"] : country
                }
              })
            })
            freezeAndUnfreezeAppointeeAddressFields(pincode,state,city,address1,areaTalukaTehsil,country);
          })

        },2000)
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
        }
        setTimeout(() => {
          fetchAllJourneyData(payload).then(data => {
            let city = ''
            let pincode = ''
            let state = ''
            let address1 = ''
            let areaTalukaTehsil = ''
            let country = ''
            let dontFreezeCountry = false;
            let addressSameAs = data.nominees[0].appointee.communicationDetails.sameAs;
            if (addressSameAs === "Primary Annuitant"){
              pincode = data.lifeAssuredDetails.communicationDetails.currentAddress.pinCode
              state = data.lifeAssuredDetails.communicationDetails.currentAddress.state
              city = data.lifeAssuredDetails.communicationDetails.currentAddress.cityMap
              address1 = data.lifeAssuredDetails.communicationDetails.currentAddress.address1
              areaTalukaTehsil = data.lifeAssuredDetails.communicationDetails.currentAddress.areaTalukaTehsil
              country = data.lifeAssuredDetails.communicationDetails.currentAddress.country
            }else if (addressSameAs === "Nominee"){
              const nominees = data.nominees;
              const firstMinorNominee = nominees.find(nominee => {
              if (getAge(nominee.dob) < 18){
                return true;
              }else{
                return false;
              }
              })
              pincode = firstMinorNominee.communicationDetails.pinCode
              city = firstMinorNominee.communicationDetails.cityMap
              state = firstMinorNominee.communicationDetails.state
              address1 = firstMinorNominee.communicationDetails.address1
              areaTalukaTehsil = firstMinorNominee.communicationDetails.areaTalukaTehsil
              country  = firstMinorNominee.communicationDetails.country 
            }else if (addressSameAs === "Others"){
              pincode = ''
              state = ''
              city = ''
              address1 = ''
              areaTalukaTehsil = ''
              let tempPageIndexToChange ;
              let tempSectionIndexToChange;
              let temp = journeyState.journeySteps
              tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
              tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "SectionPension4lifeAppointeeCommunicationDetails")
              let tempComponentGroupIndextoChangeAddress3 = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "apponiteeCountry");
              let defaultCountry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeAddress3].components[0].defaultValue
              country = defaultCountry ? defaultCountry : 'IN'
              dontFreezeCountry = true;
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["apponiteePincode"]: pincode,
                  ["appointeeState"] : state,
                  ["apponiteeCity"] : city,
                  ["addressAppointeeGuardian"] : address1,
                  ["areaTalukaTehsilApponitee"] : areaTalukaTehsil,
                  ["apponiteeCountry"] : country
                }
              })
            })
            freezeAndUnfreezeAppointeeAddressFields(pincode,state,city,address1,areaTalukaTehsil,country,dontFreezeCountry)
          })
        },2000)
      }
}
  }, [])

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

    const autoFillAndFreezeAddress = (target) => {
    if (props.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails" && props.data.formControlKey === "addressSameAsResidence") {
      let addressLine1Value
      let addressLine2Value
      let addressLine3Value
      let pincodeValue
      let stateValue
      let cityValue
      let otherCityValue
      if(target.value === "N"){
        addressLine1Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.currentPermanentAddress"]
        addressLine2Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDareaTalukaTehsil"]
        addressLine3Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDcountry"]
        pincodeValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDpincode"]
        stateValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDstate"]
        cityValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDCity"]
        otherCityValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4lifePrimaryAnnuitantCommunicationDetails.PDCityText"]
      }else{
        addressLine1Value = ""
        addressLine2Value = ""
        addressLine3Value = ""
        pincodeValue = ""
        stateValue = ""
        cityValue = ""
        otherCityValue = ""
      }

      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["currentPermanentAddress"]: addressLine1Value,
            ["PDareaTalukaTehsil"]: addressLine2Value,
            ["PDcountry"]: addressLine3Value,
            ["PDpincode"]: pincodeValue,
            ["PDstate"]: stateValue,
            ["PDCity"]: cityValue,
            ["PDCityText"]: otherCityValue
          }
        })
      })
  }
  else if (props.sectionId === "SectionPension4LifeProposerCommunication" && props.data.formControlKey === "addressSameAsResidence") {
    let addressLine1Value
    let addressLine2Value
    let addressLine3Value
    let pincodeValue
    let stateValue
    let cityValue
    let otherCityValue
    if(target.value === "N"){
      addressLine1Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.currentPermanentAddress"]
      addressLine2Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.PDareaTalukaTehsil"]
      addressLine3Value = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.PDcountry"]
      pincodeValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.proposerPermanentpincode"]
      stateValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.PDstate"]
      cityValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.PDCity"]
      otherCityValue = conditionState["PagePension4lifeFillProposalForm.SectionPension4LifeProposerCommunication.PDCityText"]
    }else{
      addressLine1Value = ""
      addressLine2Value = ""
      addressLine3Value = ""
      pincodeValue = ""
      stateValue = ""
      cityValue = ""
      otherCityValue = ""
    }

    setSectionState(prev => {
      return ({
        ...prev,
        sectionData: {
          ...prev.sectionData,
          ["currentPermanentAddress"]: addressLine1Value,
          ["PDareaTalukaTehsil"]: addressLine2Value,
          ["PDcountry"]: addressLine3Value,
          ["proposerPermanentpincode"]: pincodeValue,
          ["PDstate"]: stateValue,
          ["PDCity"]: cityValue,
          ["PDCityText"]: otherCityValue
        }
      })
    })
}
}

  const handleEnter = (event1,event2,isCard) =>{
    if(event1.key == 'Enter'){
      handleChange(event2,isCard)
    }
  }
  const handleChange = ({ target }, isCard) => {
    console.log(target.value);
    if(!props.data.disabled){
      if (sectionState.sectionId === props.sectionId) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      }
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
        }
      })

      if (target.value && isCard) {
        console.log(target.value)
        // console.log(target.value);
        // smoke-white-clr
        // console.log(target.parentElement.parentElement.parentElement)

        // radio-cards by Id
        let currentRadio = document
          .getElementById(target.value)
          .querySelector("[data-active-class]")
        console.log(currentRadio)
        // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

        // removing other active class
        let radios = arr[currentRadio.getAttribute("data-active-class")]
        radios?.forEach(radio => {
          radio.classList.remove("active")
        })

        // activate radio Radio
        currentRadio.classList.add("active")
      }

      if(!isCard && props.saveApplicationAndCallBi){
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
      console.log(sectionState, "section state")
      // console.log(conditionState, "condition state")
      if (props.pageId === "PagePension4lifeFillProposalForm" && props.sectionId === "SectionPension4lifeAppointeeCommunicationDetails" && props.data.formControlKey
      === "AppointeeSameAsPrimary" ){
     
       let payload = {
         journeyId: journeyState.journeyId,
       }
       fetchAllJourneyData(payload).then(data => {
         let city = ''
         let pincode = ''
         let state = ''
         let address1 = ''
         let areaTalukaTehsil = ''
         let country = ''
         let dontFreezeCountry = false;
         if (target.value === "Primary Annuitant"){
           pincode = data.lifeAssuredDetails.communicationDetails.currentAddress.pinCode
           state = data.lifeAssuredDetails.communicationDetails.currentAddress.state
           city = data.lifeAssuredDetails.communicationDetails.currentAddress.cityMap
           address1 = data.lifeAssuredDetails.communicationDetails.currentAddress.address1
           areaTalukaTehsil = data.lifeAssuredDetails.communicationDetails.currentAddress.areaTalukaTehsil
           country = data.lifeAssuredDetails.communicationDetails.currentAddress.country
         }else if (target.value === "Nominee"){
           const nominees = data.nominees;
           const firstMinorNominee = nominees.find(nominee => {
             if (getAge(nominee.dob) < 18){
               return true;
             }else{
               return false;
             }
           })
           pincode = firstMinorNominee.communicationDetails.pinCode
           city = firstMinorNominee.communicationDetails.cityMap
           state = firstMinorNominee.communicationDetails.state
           address1 = firstMinorNominee.communicationDetails.address1
           areaTalukaTehsil = firstMinorNominee.communicationDetails.areaTalukaTehsil
           country  = firstMinorNominee.communicationDetails.country 
         }else if (target.value === "Others"){
           pincode = ''
           state = ''
           city = ''
           address1 = ''
           areaTalukaTehsil = ''
           let tempPageIndexToChange ;
           let tempSectionIndexToChange;
           let temp = journeyState.journeySteps
           tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
           tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "SectionPension4lifeAppointeeCommunicationDetails")
           let tempComponentGroupIndextoChangeAddress3 = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "apponiteeCountry");
           let defaultCountry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeAddress3].components[0].defaultValue
           country = defaultCountry ? defaultCountry : 'IN'
           dontFreezeCountry = true;
         }
         setSectionState(prev => {
           return ({
             ...prev,
             sectionData: {
               ...prev.sectionData,
               ["apponiteePincode"]: pincode,
               ["appointeeState"] : state,
               ["apponiteeCity"] : city,
               ["addressAppointeeGuardian"] : address1,
               ["areaTalukaTehsilApponitee"] : areaTalukaTehsil,
               ["apponiteeCountry"] : country
             }
           })
         })
         freezeAndUnfreezeAppointeeAddressFields(pincode,state,city,address1,areaTalukaTehsil,country,dontFreezeCountry)
       })
    }
    autoFillAndFreezeAddress(target)
    }
  }
  const freezeAndUnfreezeAppointeeAddressFields = (appointeePincode,appointeeState,cityAppointee,address1appointee,address2appointee,country,dontFreezeCountry = false) => {
    let tempPageIndexToChange ;
    let tempSectionIndexToChange;
    let temp = journeyState.journeySteps
    tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
    tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "SectionPension4lifeAppointeeCommunicationDetails")
    let tempComponentGroupIndextoChangeAddress1 = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "addressAppointeeGuardian");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeAddress1].components[0].disabled = address1appointee ? true : false
    let tempComponentGroupIndextoChangeAddress2 = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "areaTalukaTehsilApponitee");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeAddress2].components[0].disabled = address2appointee ? true : false
    let tempComponentGroupIndextoChangeAddress3 = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "apponiteeCountry");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeAddress3].components[0].disabled = country ? (dontFreezeCountry ? false : true) : false;
    let tempComponentGroupIndextoChangePincode = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "apponiteePincode");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangePincode].components[0].disabled = appointeePincode ? true : false
    let tempComponentGroupIndextoChangeState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "appointeeState");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeState].components[0].disabled = appointeeState ? true : false
    let tempComponentGroupIndextoChangeCity = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "apponiteeCity");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChangeCity].components[0].disabled = cityAppointee ? true : false
    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })
  }
  return (
    <>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }
        
        `}
      </style>
      {radioCardFormControlKey.includes(props.data.formControlKey) ? (
        <>
          <p className="text-left plan-heading new-heading-font">
          {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
        {props.data.tooltip &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                props.data.tooltip
                              )))}
                            </span>
                          </span>
                        }
          </p>

          {carouselFormControlKey.includes(props.data.formControlKey) ? (
            <div className="row radio-card-container">
              <Swiper
                navigation={true}
                autoplay={true}
                breakpoints={breakpoints(props.data.radioComponent.length)}
              >
                {props.data.radioComponent.map((element, i) => {
                  return (
                    <SwiperSlide>
                      <div
                        className={`radio-card ${element.class}`}
                        style={{
                          width:"100%"
                        }}
                        key={i}
                        name={element.name}
                        id={element.value}
                        checked={
                          sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                          : element.checked
                        }
                        
                        onKeyPress= {(e)=>handleEnter(e,
                          { target: { value: element.value } },
                          true
                        )}
                        onClick={e =>
                          handleChange(
                            { target: { value: element.value } },
                            true
                          )
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: element.html }}
                        />
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          ) : (
            <div className="row radio-card-container ">
              {tabFormControlKey.includes(props.data.formControlKey) ? (
                <div className="radio-tab hidden-lg hidden-md hidden-sm ">
                  {props.data.radioComponent.map((el, i) => {
                    if (el.label) {
                      return (
                        <div
                          className={`${
                            props.data.radioComponent[0].name == el.name
                              ? "active-tab"
                              : ""
                          }`}
                        >
                          <p
                            data-active-tab={el.value}
                            aria-hidden="true"
                            onClick={e => handleActiveTab(e, el.name)}
                            className="text-center"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {el.label}
                          </p>
                        </div>
                      )
                    }
                  })}
                </div>
              ) : null}
              {props.data.radioComponent.map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                        : element.checked
                    }
                    onKeyPress= {(e)=>handleEnter(e,
                      { target: { value: element.value } },
                      true
                    )}
                    onClick={e =>
                      handleChange({ target: { value: element.value } }, true)
                    }
                  >
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                        {element.label}
                      </p>
                    ) : null}
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: element.html }}
                        className={activeTab == element.name ? "" : "hidden-xs"}
                      />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: element.html }} />
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="form-group">
            <div className="radio-section-design">
              <p>{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</p>
            </div>
            {props.data.radioComponent.map((element, i) => {
              return (
                <div className="radio-line radio-design" key={i}>
                  <label className="customradio">
                    <span className="radiotextsty inp-label">{(getValueFromJourney(
                                                                    journeyState.lookup.label,
                                                                    element.label
                                                               )) || element.label}
                                                               {element.tooltip &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                element.tooltip
                              )))}
                            </span>
                          </span>
                        }
                        </span>
                    <input
                      type={element.type}
                      name={element.name}
                      id={element.value}
                      value={element.value}
                      checked={ sectionState.sectionData &&
                        sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                              props.data.formControlKey
                            ] === element.value
                          : element.checked
                      }
                      onChange={handleChange}
                    />
                    <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:element.value}},false)}  ></span>
                  </label>
                </div>
              )
            })}
          </div>
        </>
      )}
    </>
  )
}
